var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2220_11209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2220_11209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stylus",
    d: "M6.80453 17.9797C6.57094 18.0353 6.36795 17.9769 6.19554 17.8045C6.02313 17.6321 5.96473 17.4291 6.02035 17.1955L6.60431 14.3591L9.64094 17.3957L6.80453 17.9797ZM10.7254 16.5781L7.42187 13.2746L14.3127 6.38375C14.5685 6.12792 14.8855 6 15.2637 6C15.6419 6 15.9589 6.12792 16.2147 6.38375L17.6163 7.78527C17.8721 8.0411 18 8.35811 18 8.7363C18 9.11449 17.8721 9.4315 17.6163 9.68733L10.7254 16.5781Z",
    fill: "#727C8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.68f9d4cf4eae8d494d71f98aa9b58ee8.svg";
export { ForwardRef as ReactComponent };